import {CatalogItemIcon, GiftCardImage, KyooPromo, Merchant, MerchantMobileApp, MobileAppHomepageTile, MobileAppMenuTab, Notification} from '../models/restaurant.model';
import {ImageConfig} from '../enums/merchant.enum';

export const dataToMerchantInfo = (data: any, merchantId: string): Merchant => {
  return new Merchant(
    merchantId,
    data.merchant_name,
    data.merchant_email,
    data.merchant_header_title,
    data.merchant_header_text,
    data.available,
    data.merchant_banner,
    data.merchant_logo,
    data.show_locations_map,
    data.miles_away_threshold,
    data.location_image_type ? data.location_image_type : ImageConfig.default,
    data.location_image_url,
    data.category_filter_enabled,
    data.vanity_link,
    data.use_flavor_shifts_time
  );
};

export const dataToMerchantMobileAppInfo = (data: any, id: string): MerchantMobileApp => {
  return new MerchantMobileApp(
    id,
    data.merchant_name,
    data.merchant_email,
    data.name,
    data.subtitle,
    data.description,
    data.tagline,
    data.home_screen_summary,
    data.about_page_url,
    data.learn_more_page_url,
    data.splash_screen_image_url,
    data.home_screen_image_url,
    data.icon_url,
    data.banner_url,
    data.image_url,
    data.display_gift_cards,
    data.display_popular_items,
    data.display_frequently_ordered_items,
    data.display_our_store_message,
    data.our_store_message,
    data.is_private,
    data.display_profile_photo,
    data.enable_desktop,
    data.one_signal_app_id
  );
};

export const dataToMerchantGiftCardImage = (data: any): GiftCardImage => {
  return new GiftCardImage(
    data.id,
    data.imageUrl,
    data.defaultImage
  );
}

export const dataToMobileAppMenuTab = (data: any, id: string): MobileAppMenuTab => {
  return new MobileAppMenuTab(
    id,
    data.title,
    data.redirect,
    data.redirectUrl,
    data.content
  );
};

export const dataToMobileAppHomepageTile = (data: any, id: string): MobileAppHomepageTile => {
  return new MobileAppHomepageTile(
    id,
    data.title,
    data.orderNumber,
    data.description,
    data.imageUrl,
    data.redirectButton,
    data.buttonText,
    data.redirectUrl,
    data.productButton,
    data.locationId,
    data.categoryId,
    data.itemId,
    data.promoButton,
    data.promoImageUrl,
    data.backgroundColor,
    data.navigationPath,
    data.showAsPopup,
    data.showAsBanner,
    data.discountId,
    data.discountName,
    data.discountTerms,
    !!data.useCurrentLocation
  );
};

export const dataToCatalogItemIcon = (data: any, id: string): CatalogItemIcon => {
  return new CatalogItemIcon(
    id,
    data.itemId,
    data.merchantId,
    data.svgIconText
  )
}

export const dataToNotification = (data: any, id:string): Notification => {
  return new Notification(
    id,
    data.title,
    data.message,
    new Date(data.scheduledTime),
    data.notificationId
  )
}

export const dataToPromos = (data: any): KyooPromo => {
  return new KyooPromo(
    data.id,
    data.type,
    data.itemId,
    data.spendPrice,
    data.promoPrice,
    data.isActive
  )
}
